import { SVGProps } from "react"
const Divider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1}
    height={16}
    fill="none"
    {...props}
  >
    <path stroke="#DCDFE4" d="M.5 0v16" />
  </svg>
)
export default Divider
